import { NavLink, useParams } from "react-router-dom";
import { useState } from "react";
import { Drawer, IconButton, Box } from "@mui/material";
import ListIcon from "@mui/icons-material/List";
import { assetTypeMap } from "../leases/components/LeaseConstants";

const AssetsNav = () => {
  const params = useParams();
  const [open, setOpen] = useState(false);
  const AssetType = Number.isNaN(Number(params?.asset_type))
    ? Number(Object.keys(assetTypeMap).find((key) => assetTypeMap[key] === params?.asset_type))
    : Number(params?.asset_type);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const AssetsNavLinks = [
    { path: `/assets/${AssetType}/${params?.asset_type}/${params?.asset_slug}/leases`, label: "Leases" },
    { path: `/assets/${AssetType}/${params?.asset_type}/${params?.asset_slug}/mou`, label: "MOU" },
    // { path: `/assets/${params?.basic_info}/${params?.asset_type}/${params?.asset_slug}/financing-details`, label: "Financing Details" },
    // { path: `/assets/${params?.basic_info}/${params?.asset_type}/${params?.asset_slug}/loan-amortization`, label: "Loan Amortization" },
  ]

    return (
        <>
            <Box className="mobile-pry-container" sx={{position: 'absolute', display: {xs: 'none'}}}>
                <IconButton onClick={toggleDrawer(true)}>
                    <ListIcon />
                </IconButton>
                <Drawer anchor="left" open={open} onClose={toggleDrawer(false)} PaperProps={{ sx: { width: 280, backgroundColor: "#6b5eb0", color: "#fff", overflowY: "auto", }, }} >
                    <Box sx={{ py: 1 }}>
                        {AssetsNavLinks.map(({ path, label }) => (
                            <NavLink key={path} to={path} onClick={() => setOpen(false)} className={({ isActive }) => (isActive ? "active" : "")} style={{ display: "block", padding: "12px 20px", color: "#fff", textDecoration: "none", fontFamily: "Roboto", fontSize: "14px", borderBottom: "1px solid #fff" }} > {label} </NavLink>
                        ))}
                    </Box>
                </Drawer>
            </Box>
            <div className='leases-nav'>
                {AssetsNavLinks.map(({ path, label }) => (
                    <div className='leases-nav-link' key={path}>
                        <NavLink to={path} className={({ isActive }) => (isActive ? "active" : "")}>{label}</NavLink> 
                    </div>
                ))}
            </div>
        </>
    );
};

export default AssetsNav;
